import { render, staticRenderFns } from "./DataQualityIssues.vue?vue&type=template&id=418183b4&"
import script from "./DataQualityIssues.js?vue&type=script&lang=js&"
export * from "./DataQualityIssues.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports